var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',_vm._b({attrs:{"prefix":_vm.options.prefix,"suffix":_vm.options.suffix,"hack-value":_vm.cmpValue = _vm.value},on:{"keypress":_vm.keyPress},model:{value:(_vm.cmpValue),callback:function ($$v) {_vm.cmpValue=$$v},expression:"cmpValue"}},'v-text-field',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }